import { FC } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/admin/Sidebar.tsx";

const AdminLayout: FC = () => {
  return (
    <div className="flex min-h-screen">
      {/* Example sidebar */}
      <aside className="w-64 bg-gray-800 text-white p-4">
        <h2 className="text-xl font-bold mb-4">Admin Panel</h2>
        {/* Add sidebar links here */}
        <Sidebar />
      </aside>
      {/* Main content - full width */}
      <main className="flex-1 p-8 bg-gray-100 w-full">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
